import { Loan } from '../../interfaces';
import { LoanAction } from '../actions/loan.actions';
import { ActionType } from '../action_types';

interface LoanState {
  loan?: Loan | null;
  canDisburseLoan: boolean;
}

const initialState: LoanState = {
  loan: null,
  canDisburseLoan: false,
};

const loanReudcer = (state = initialState, action: LoanAction): LoanState => {
  switch (action.type) {
    case ActionType.GET_LOAN:
      return { ...state, loan: action.payload.loan };
    case ActionType.UPDATE_LOAN_STATUS:
      return { ...state, loan: { ...state.loan!, loan_status_id: action.payload.status } };
    case ActionType.UPDATE_LOAN_DISBURSEMENT_CHECKER:
      return { ...state, canDisburseLoan: action.payload.status };
    default:
      return { ...state };
  }
};

export default loanReudcer;
